var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5401_49324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83334 18.6667V14.2501C8.83334 13.9167 9.16668 13.6667 9.50001 13.6667H12C12.3333 13.6667 12.6667 14.0001 12.6667 14.3334V18.6667C12.6667 19.0001 12.9167 19.3334 13.3333 19.3334H18.3333C18.6667 19.3334 19 19.0834 19 18.6667V9.91675C19 9.75008 19 9.58341 18.8333 9.50008L11.0833 1.91675C10.8333 1.66675 10.4167 1.66675 10.1667 1.91675L2.75001 9.41675C2.66668 9.50008 2.58334 9.66675 2.58334 9.83341V18.5834C2.58334 18.9167 2.83334 19.2501 3.25001 19.2501H8.25001C8.58334 19.2501 8.91668 19.0001 8.91668 18.5834L8.83334 18.6667Z",
    stroke: "#2362A2",
    strokeWidth: 2.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5401_49324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.666672 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.68153455ece1164a36fa775ab4eb8833.svg";
export { ForwardRef as ReactComponent };